<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import { MicOff } from 'lucide-svelte';
  import LevelMeter from '../molecules/LevelMeter.svelte';

  interface Props {
    name: string;
    isMe?: boolean;
    audioLevel?: number;
    muted?: boolean;
    connected?: boolean;
  }

  let { name, isMe = false, audioLevel = 0, muted = false, connected = true }: Props = $props();

  const speaking = $derived(audioLevel > 0.15 && !muted);
  const glowScale = $derived(1 + Math.min(0.4, audioLevel * 0.7));
  const initial = $derived((name.charAt(0) || '?').toUpperCase());

  const statusLabel = $derived(
    isMe ? 'Вы' : connected ? (speaking ? 'Говорит' : 'Подключён') : 'Соединение…',
  );

  const avatarTone = $derived(
    isMe
      ? 'from-indigo-500 to-purple-500 shadow-indigo-500/30'
      : 'from-cyan-500 to-blue-500 shadow-cyan-500/20',
  );
</script>

<div
  class="relative backdrop-blur-xl bg-white/5 border rounded-2xl p-4 transition-all duration-200 {speaking
    ? 'border-green-400/60 bg-green-400/5'
    : 'border-white/10'}"
>
  <div class="flex flex-col items-center">
    <div class="relative mb-3 w-16 h-16">
      <div
        class="absolute inset-0 rounded-full transition-all duration-150 {speaking
          ? 'bg-green-400/30'
          : 'bg-transparent'}"
        style:transform="scale({speaking ? glowScale : 1})"
      ></div>
      <div
        class="relative w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold text-white bg-gradient-to-br shadow-lg {avatarTone}"
      >
        {initial}
      </div>
      {#if muted}
        <div
          class="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-red-500 flex items-center justify-center border-2 border-slate-950 z-10"
          aria-label="Микрофон выключен"
        >
          <MicOff class="w-3 h-3 text-white" />
        </div>
      {:else if !connected && !isMe}
        <div
          class="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-amber-500 flex items-center justify-center border-2 border-slate-950 z-10 animate-pulse"
          aria-label="Соединение"
        >
          <div class="w-2 h-2 bg-white rounded-full"></div>
        </div>
      {/if}
    </div>
    <div class="text-white font-medium text-sm truncate max-w-full text-center">{name}</div>
    <div class="text-xs text-slate-500 mt-0.5">{statusLabel}</div>
    <div class="mt-2 w-full">
      <LevelMeter level={audioLevel} {muted} />
    </div>
  </div>
</div>
